import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import DataAid from '../../common/constants/data-aids';
import Field from '../../common/constants/editable-field-tags';

class LayoutWrapper extends Component {
  static get propTypes() {
    return {
      children: PropTypes.node,
      background: PropTypes.object,
      backgroundHeight: PropTypes.string,
      backgroundImage: PropTypes.string,
      backgroundLeft: PropTypes.string,
      backgroundPosition: PropTypes.string,
      backgroundRotation: PropTypes.string,
      backgroundTop: PropTypes.string,
      backgroundWidth: PropTypes.string,
      category: PropTypes.string,
      section: PropTypes.string,
      sectionTitle: PropTypes.string,
      slug: PropTypes.string
    };
  }

  renderPostContent(sectionProps = {}) {
    const {
      category = this.props.category,
      section = this.props.section,
      style = {}
    } = sectionProps;
    const { children, sectionTitle } = this.props;

    return (
      <UX2.Group.Section.Banner category={ category } section={ section } style={ style }>
        <UX2.Element.Container>
          { sectionTitle && (
            <UX2.Element.Heading
              data-aid={ DataAid.RSS_SECTION_TITLE_RENDERED }
              data-route={ Field.SECTION_TITLE }
            >
              { sectionTitle }
            </UX2.Element.Heading>
          ) }
        </UX2.Element.Container>
        <UX2.Element.Container category={ category } section={ section }>
          { children }
        </UX2.Element.Container>
      </UX2.Group.Section.Banner>
    );
  }

  renderWithImage() {
    const { backgroundPosition, background } = this.props;
    const sectionProps = {
      category: 'accent',
      section: 'overlay',
      style: { backgroundColor: '!transparent' }
    };
    return (
      <UX2.Component.Widget.Banner { ...this.props }>
        <UX2.Component.Background
          data-aid={ DataAid.RSS_SECTION_BACKGROUND }
          style={{ backgroundSize: 'cover', backgroundPosition }}
          imageData={ background }
          { ...sectionProps }
        >
          { this.renderPostContent(sectionProps) }
        </UX2.Component.Background>
      </UX2.Component.Widget.Banner>
    );
  }

  render() {
    const { backgroundImage, slug } = this.props;
    const isAllPostsView = !slug;
    const showBackgroundImage = backgroundImage && isAllPostsView;

    return showBackgroundImage ? (
      this.renderWithImage()
    ) : (
      <UX2.Component.Widget.Banner { ...this.props }>
        { this.renderPostContent() }
      </UX2.Component.Widget.Banner>
    );
  }
}

export default LayoutWrapper;
